export { default } from './RewardsPage';
